import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {ReportStore} from '../../../shared/store/report/report.store';
import {ReportTransactionIdStore} from '../../../shared/store/report/report-transaction-id.store';
import {AdRequestParams} from '../../../shared/interfaces/ad-reports';
import {ReportParamsStore} from '../../../shared/store/report/report-params.store';
import {PublicReportData} from '../../../shared/store/publicReports/public-reports';

@Component({
  selector: 'app-transaction-id-report',
  templateUrl: './transaction-id-report.component.html',
  styleUrls: ['./transaction-id-report.component.scss'],
  providers: [
    ReportStore,
    ReportParamsStore,
    ReportTransactionIdStore
  ]
})
export class TransactionIdReportComponent implements OnInit, OnDestroy {
  public readonly loading$: Observable<boolean> = this._reportTransactionIdStore.loading$;
  public readonly details$: Observable<any> = this._reportTransactionIdStore.details$;
  public readonly requestParams$: Observable<Partial<AdRequestParams>> = this._reportStore.requestParams$;

  @Input('publicReportData') set setReport(publicReportData: PublicReportData | null | undefined) {
    if (publicReportData) {
      this._reportStore.initPublicReport(
        publicReportData.report,
        publicReportData.uuid,
        publicReportData.token
      );
    }
  };

  constructor(
    private readonly _reportStore: ReportStore,
    private readonly _reportTransactionIdStore: ReportTransactionIdStore
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

}
